'use client';

import { ReactNode } from 'react';
import { StarterInitialContent } from './EpStarterInitialContent';
import clsx from 'clsx';
import { EpAlertToaster } from '../../../components/EpAlertToaster';
import styles from '../EpStarter.module.scss';

interface IStarterContentProps {
  children?: ReactNode;
  logged?: boolean;
  tag?: string;
  template?:
    | 'default'
    | 'clinical-pharmacy'
    | 'patient-safety'
    | 'public-patient-safety';
}

export const StarterContent = ({
  children,
  logged,
  tag,
  template = 'default',
}: IStarterContentProps) => {
  const contentTemplate = {
    default: children,
    'clinical-pharmacy': (
      <StarterInitialContent.HomeClinicalPharmacy tag={tag} logged />
    ),
    'public-patient-safety': (
      <StarterInitialContent.HomePublicPS tag={tag} logged={logged} />
    ),
    'patient-safety': (
      <StarterInitialContent.HomePS tag={tag} logged={logged} />
    ),
  };

  const translations = {
    successDefaultTitle: 'Success!',
    warningDefaultTitle: 'Warning!',
    dangerDefaultTitle: 'Error!',
  };

  return (
    <section
      className={clsx(
        styles['section'],
        template !== 'default' && styles['section--row'],
      )}
    >
      {contentTemplate[template]}
      <EpAlertToaster translations={translations} />
    </section>
  );
};
